import { ref, readonly } from 'vue';

const _title = ref('Carte Confituur  |  grafisch ontwerpstudio');
const _metaData = ref([]);
export const pageTitle = readonly(_title);
export const metaData = readonly(_metaData);

export const setPageTitle = (v: string) => (_title.value = v);
export const setMetaData = (v: any) => (_metaData.value = v);